import { GeneralAwarenessRibbonIcon, Tooltip } from '@outdoorsyco/bonfire';
import React from 'react';
import { useIntl } from 'react-intl';

interface IMilitaryHostBadgeProps {
  className?: string;
  width?: number;
  height?: number;
  // Render the tooltip at <body> level. Needed when the badge sits inside an
  // `overflow: hidden` container (e.g. the search-map card/carousel) that would
  // otherwise clip the tooltip or stack it below sibling controls.
  usePortal?: boolean;
  onMouseEnter?: (e: React.MouseEvent<HTMLSpanElement>) => void;
  onMouseLeave?: (e: React.MouseEvent<HTMLSpanElement>) => void;
}

export const MilitaryHostBadge = ({
  className,
  width = 24,
  height = 24,
  usePortal,
  onMouseEnter,
  onMouseLeave,
}: IMilitaryHostBadgeProps) => {
  const intl = useIntl();
  return (
    <Tooltip
      content={intl.formatMessage({
        id: 'Zc3erG',
        defaultMessage: 'This host is an active or retired military member.',
        description: 'Military host badge tooltip on listing tile',
      })}
      className={className}
      usePortal={usePortal}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}>
      <GeneralAwarenessRibbonIcon width={width} height={height} />
    </Tooltip>
  );
};
